/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesLocationCountries.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Location Country Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 05:55:18 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const LocationCountryList = Loadable({
    loader: () => import('../containers/LocationCountries/LocationCountryListContainer'),
    loading: Loading,
});

export const LocationCountryForm = Loadable({
    loader: () => import('../containers/LocationCountries/LocationCountryEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesLocationCountries.js